import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {AdxBookingPassenger} from '../../models/adx-booking-passenger.model';
import {AdxBookingPassengerService} from '../../service/adx-booking-passenger.service';
import {MatSnackBar} from '@angular/material/snack-bar';

interface PassengerData {
  bookingId: number;
  bookingNo?: string;
}

@AutoUnsubscribe()
@Component({
    selector: 'app-adx-booking-passengers-modal',
    templateUrl: './adx-booking-passengers-modal.component.html',
    styleUrls: ['./adx-booking-passengers-modal.component.scss'],
    standalone: false
})
export class AdxBookingPassengersModalComponent implements OnInit {
  bookingId: number = 0;
  bookingNo: string = '';
  passengers: AdxBookingPassenger[] = [];
  hasData: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AdxBookingPassengersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PassengerData,
    private passengerService: AdxBookingPassengerService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.bookingId = this.data.bookingId;
      this.bookingNo = this.data.bookingNo ? this.data.bookingNo : this.bookingId.toString();
      this.loadPassengers();
    }
  }

  loadPassengers(): void {
    this.passengerService.getPassengersByBookingId(this.bookingId).subscribe({
      next: (passengers) => {
        this.passengers = passengers;
        this.hasData = passengers.length > 0;
      },
      error: (error) => {
        this.hasData = false;
        this.snackBar.open('Failed to load passengers', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
        console.error('Error loading passengers:', error);
      }
    });
  }

  getFullName(passenger: AdxBookingPassenger): string {
    const parts = [
      passenger.firstname,
      passenger.middlename,
      passenger.lastname
    ].filter(Boolean);
    return parts.join(' ');
  }

  close(): void {
    this.dialogRef.close();
  }
}
